// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jw-title-clips>.row>[class*=col-]{margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
